/**
 * Plugin per l'installazione del componenente WGModal e del relativo modulo dello store
 * con le opzioni giuste
 */
import WGModal from '../components/WGModal.vue';
import ModalModule from '../storeModules/modal';

export default {
  install(Vue, {store, categories}) {
    /**
     * Deve essere necessariamente passata l'istanza di vuex store
     */
    if(!store) {
      throw new Error("Please provide vuex store");
    }

    /**
     * Registrazione del modulo dello store associato al menu
     */
    store.registerModule('modal', ModalModule);

    /**
     * Registrazione componente del menu
     */
    Vue.component('wg-modal', WGModal);
  }
}